module.exports = __webpack_public_path__ + "img/HC2021-38.f2c1cad2.jpg";